module.exports = __webpack_public_path__ + "assets/img/tb01.0d6acde6.png";